export const getDateFormatOptions = (timeZone: string): Intl.DateTimeFormatOptions => ({
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  timeZone,
});

export const addZero = (value: number, length = 2) => {
  return String(value).padStart(length, "0");
};

export const dateToDMY = (date: Date, timeZone: string) => {
  return date.toLocaleDateString("fr-FR", { day: "2-digit", month: "2-digit", year: "numeric", timeZone });
};

export const formatForData = (date: Date, timeZone: string): string => {
  return date.toLocaleString("fr-CA", { year: "numeric", month: "2-digit", day: "2-digit", timeZone });
};
